import Vue from 'vue/dist/vue.esm.js'
import $ from 'jquery'
import 'bootstrap'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css'
import 'bootstrap-datepicker'

Vue.component('datepicker',
  props: ['value']
  template: "<input type='text' size='10' maxlength='10' v-bind:value='value'
 />"
  mounted: ->
    # activate the plugin when the component is mounted.
    $(@$el).datepicker(
      format: "dd-mm-yyyy"
      language: I18n.locale
    ).on('change', @changeValue.bind(this))
  methods:
    # callback for when the selector popup is closed.
    changeValue: (e) ->
      # !!! 'this' is the component
      value = e.target.value
      @$emit('input', value)
      @currentValue = value
)
